import {
  ChangeDetectionStrategy,
  Component,
  Input,
  numberAttribute,
} from '@angular/core';

@Component({
  selector: 'ds-loading-spinner',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span
      class="ds-loading-spinner"
      [style.--ds-loading-spinner-duration]="animationDurationMs + 'ms'"
      role="progressbar"
      [attr.aria-label]="ariaLabel"
    >
      <span class="ds-loading-spinner__dot ds-loading-spinner__dot--1"></span>
      <span class="ds-loading-spinner__dot ds-loading-spinner__dot--2"></span>
      <span class="ds-loading-spinner__dot ds-loading-spinner__dot--3"></span>
      <span class="ds-loading-spinner__dot ds-loading-spinner__dot--4"></span>
      <span class="ds-loading-spinner__dot ds-loading-spinner__dot--5"></span>
      <span class="ds-loading-spinner__dot ds-loading-spinner__dot--6"></span>
    </span>
  `,
  styles: [`
    :host {
      display: inline-flex;
      width: var(--ds-loading-spinner-size);
      height: var(--ds-loading-spinner-size);
      line-height: 0;
    }

    .ds-loading-spinner {
      --ds-loading-spinner-duration: var(--ds-loading-spinner-animation-duration);
      --ds-loading-spinner-cluster-radius: calc(var(--ds-loading-spinner-dot-size) * 1.1);
      position: relative;
      display: inline-block;
      width: var(--ds-loading-spinner-size);
      height: var(--ds-loading-spinner-size);
      animation: ds-loading-spinner-rotate var(--ds-loading-spinner-duration) linear infinite;
    }

    .ds-loading-spinner__dot {
      --ds-loading-spinner-angle: 0deg;
      --ds-loading-spinner-angle-inverse: 0deg;
      position: absolute;
      top: 50%;
      left: 50%;
      width: var(--ds-loading-spinner-dot-size);
      height: var(--ds-loading-spinner-dot-size);
      margin-top: calc(var(--ds-loading-spinner-dot-size) / -2);
      margin-left: calc(var(--ds-loading-spinner-dot-size) / -2);
      border-radius: 50%;
      background: var(--ds-loading-spinner-dot-color);
      animation: ds-loading-spinner-collapse var(--ds-loading-spinner-duration) linear infinite;
    }

    .ds-loading-spinner__dot--1 {
      --ds-loading-spinner-angle: 0deg;
      --ds-loading-spinner-angle-inverse: 0deg;
    }

    .ds-loading-spinner__dot--2 {
      --ds-loading-spinner-angle: 60deg;
      --ds-loading-spinner-angle-inverse: -60deg;
    }

    .ds-loading-spinner__dot--3 {
      --ds-loading-spinner-angle: 120deg;
      --ds-loading-spinner-angle-inverse: -120deg;
    }

    .ds-loading-spinner__dot--4 {
      --ds-loading-spinner-angle: 180deg;
      --ds-loading-spinner-angle-inverse: -180deg;
    }

    .ds-loading-spinner__dot--5 {
      --ds-loading-spinner-angle: 240deg;
      --ds-loading-spinner-angle-inverse: -240deg;
    }

    .ds-loading-spinner__dot--6 {
      --ds-loading-spinner-angle: 300deg;
      --ds-loading-spinner-angle-inverse: -300deg;
    }

    @keyframes ds-loading-spinner-rotate {
      0% { transform: rotate(0deg); }
      25% { transform: rotate(90deg); }
      45% { transform: rotate(136.8deg); }
      61.67% { transform: rotate(169.2deg); }
      85% { transform: rotate(306deg); }
      100% { transform: rotate(360deg); }
    }

    @keyframes ds-loading-spinner-collapse {
      0%,
      25%,
      85%,
      100% {
        transform: rotate(var(--ds-loading-spinner-angle))
          translateX(var(--ds-loading-spinner-orbit-radius))
          rotate(var(--ds-loading-spinner-angle-inverse));
      }

      45%,
      61.67% {
        transform: rotate(var(--ds-loading-spinner-angle))
          translateX(var(--ds-loading-spinner-cluster-radius))
          rotate(var(--ds-loading-spinner-angle-inverse));
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .ds-loading-spinner,
      .ds-loading-spinner__dot {
        animation-duration: 2400ms;
      }
    }
  `],
})
export class DsLoadingSpinnerComponent {
  @Input({ transform: numberAttribute }) animationDurationMs = 1200;
  @Input() ariaLabel = 'Cargando';
}
